// M12 等差數列與等比數列 - 主題 21-29 數據文件
// Topics 21-29: 部分和關係, 無限和公式, 無窮等比, 等比遞減, 等比增長, 等差求和, 絕對值公比判斷, 項數計算, 聯立方程

// M12_21: 部分和關係 (5題)
export const M12_21_PROBLEMS = [
  {
    id: 'M12_21_P001',
    topicId: 'M12_21',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等差數列部分和的關係：',
    parts: {
      a: '已知等差數列 {aₙ} 的前n項和 Sₙ = n² + 2n',
      b: '求通項公式 aₙ',
      c: '驗證 S₅ 和前5項的關係'
    },
    solution: {
      a: '由 Sₙ = n² + 2n\\n當n=1時：S₁ = a₁ = 1 + 2 = 3\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁ = (n² + 2n) - [(n-1)² + 2(n-1)]\\n= n² + 2n - (n² - 2n + 1 + 2n - 2) = 2n + 1',
      b: '檢驗n=1：a₁ = 2×1 + 1 = 3 ✓\\n所以通項公式：aₙ = 2n + 1\\n這是首項a₁=3，公差d=2的等差數列',
      c: 'S₅ = 5² + 2×5 = 35\\n前5項：a₁=3, a₂=5, a₃=7, a₄=9, a₅=11\\n和：3+5+7+9+11 = 35 ✓'
    },
    hint: {
      a: '用 Sₙ 與 Sₙ₋₁ 的關係求 aₙ',
      b: '檢驗n=1的情況',
      c: '直接計算驗證'
    },
    tags: ['部分和', '通項公式', '等差數列'],
    difficulty: 3,
    order: 1
  },
  {
    id: 'M12_21_P002',
    topicId: 'M12_21',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '等比數列部分和的關係：',
    parts: {
      a: '已知等比數列 {aₙ} 的前n項和 Sₙ = 3ⁿ - 1',
      b: '求通項公式 aₙ',
      c: '驗證等比數列性質'
    },
    solution: {
      a: '當n=1時：S₁ = a₁ = 3¹ - 1 = 2\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁ = (3ⁿ - 1) - (3ⁿ⁻¹ - 1) = 3ⁿ - 3ⁿ⁻¹ = 3ⁿ⁻¹(3-1) = 2×3ⁿ⁻¹',
      b: '檢驗n=1：a₁ = 2×3⁰ = 2 ✓\\n所以通項公式：aₙ = 2×3ⁿ⁻¹\\n這是首項a₁=2，公比r=3的等比數列',
      c: '驗證：aₙ₊₁/aₙ = (2×3ⁿ)/(2×3ⁿ⁻¹) = 3 (常數) ✓\\n用求和公式：Sₙ = 2×(3ⁿ-1)/(3-1) = 3ⁿ - 1 ✓'
    },
    hint: {
      a: '注意n=1和n≥2的不同處理',
      b: '檢驗首項是否符合',
      c: '用等比數列性質驗證'
    },
    tags: ['部分和', '等比數列', '通項推導'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_21_P003',
    topicId: 'M12_21',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '數列部分和的遞推關係：',
    parts: {
      a: '已知 Sₙ = 2Sₙ₋₁ + 3 (n≥2)，S₁ = 5',
      b: '求 {Sₙ} 的通項公式',
      c: '求原數列 {aₙ} 的通項公式'
    },
    solution: {
      a: '遞推關係：Sₙ = 2Sₙ₋₁ + 3\\n設 Tₙ = Sₙ + k，使 {Tₙ} 成等比數列\\nTₙ = Sₙ + k = 2Sₙ₋₁ + 3 + k = 2(Tₙ₋₁ - k) + 3 + k = 2Tₙ₋₁ - k + 3\\n要使比值為常數，需 -k + 3 = 0，即 k = 3',
      b: 'Tₙ = Sₙ + 3 是等比數列，T₁ = S₁ + 3 = 8，公比r = 2\\nTₙ = 8 × 2ⁿ⁻¹ = 2ⁿ⁺²\\n所以 Sₙ = 2ⁿ⁺² - 3',
      c: 'a₁ = S₁ = 5\\n當n≥2時：aₙ = Sₙ - Sₙ₋₁ = (2ⁿ⁺² - 3) - (2ⁿ⁺¹ - 3) = 2ⁿ⁺² - 2ⁿ⁺¹ = 2ⁿ⁺¹\\n檢驗：a₂ = 2³ = 8，S₂ = 5 + 8 = 13 = 2⁴ - 3 ✓'
    },
    hint: {
      a: '構造輔助數列',
      b: '解等比數列求通項',
      c: '用部分和關係求aₙ'
    },
    tags: ['遞推關係', '輔助數列', '等比變換'],
    difficulty: 4,
    order: 3
  },
  {
    id: 'M12_21_P004',
    topicId: 'M12_21',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '奇偶項部分和的關係：',
    parts: {
      a: '數列 {aₙ}: a₁=1, a₂=3, aₙ₊₂ = aₙ + 4',
      b: '分別求奇數項和偶數項的部分和',
      c: '求前2n項和 S₂ₙ'
    },
    solution: {
      a: '奇數項：a₁=1, a₃=5, a₅=9, ...，公差d=4\\n偶數項：a₂=3, a₄=7, a₆=11, ...，公差d=4\\n都是等差數列',
      b: '奇數項前n項和：T₁ₙ = n×1 + n(n-1)×4/2 = n + 2n(n-1) = n(2n-1)\\n偶數項前n項和：T₂ₙ = n×3 + n(n-1)×4/2 = 3n + 2n(n-1) = n(2n+1)',
      c: 'S₂ₙ = T₁ₙ + T₂ₙ = n(2n-1) + n(2n+1) = n[(2n-1) + (2n+1)] = n×4n = 4n²\\n驗證：S₄ = 1+3+5+7 = 16 = 4×2² ✓'
    },
    hint: {
      a: '分別考慮奇偶位置的項',
      b: '各自按等差數列求和',
      c: '合併奇偶項的和'
    },
    tags: ['奇偶項', '分組求和', '等差數列'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_21_P005',
    topicId: 'M12_21',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '部分和的比值關係：',
    parts: {
      a: '等差數列 {aₙ} 滿足 S₃ : S₆ : S₉ = 1 : 3 : 6',
      b: '求 a₁ : a₂ : a₃ 的比值',
      c: '求 a₄ : a₅ : a₆ 的比值'
    },
    solution: {
      a: '設 S₃ = k, S₆ = 3k, S₉ = 6k\\n由 Sₙ = na₁ + n(n-1)d/2:\\nS₃ = 3a₁ + 3d = k\\nS₆ = 6a₁ + 15d = 3k\\nS₉ = 9a₁ + 36d = 6k',
      b: '由前兩式：6a₁ + 15d = 3(3a₁ + 3d) = 9a₁ + 9d\\n得 -3a₁ + 6d = 0，即 a₁ = 2d\\n代入：3×2d + 3d = k，得 9d = k，所以 d = k/9, a₁ = 2k/9\\na₁ = 2k/9, a₂ = a₁ + d = 3k/9 = k/3, a₃ = a₁ + 2d = 4k/9\\n所以 a₁ : a₂ : a₃ = 2k/9 : k/3 : 4k/9 = 2 : 3 : 4',
      c: 'a₄ = a₁ + 3d = 5k/9, a₅ = a₁ + 4d = 6k/9 = 2k/3, a₆ = a₁ + 5d = 7k/9\\n所以 a₄ : a₅ : a₆ = 5k/9 : 2k/3 : 7k/9 = 5 : 6 : 7'
    },
    hint: {
      a: '利用等差數列求和公式',
      b: '建立關於a₁和d的方程組',
      c: '用已求出的a₁和d計算'
    },
    tags: ['部分和比值', '等差數列', '比例關係'],
    difficulty: 4,
    order: 5
  }
];

// M12_22: 無限和公式 (5題)
export const M12_22_PROBLEMS = [
  {
    id: 'M12_22_P001',
    topicId: 'M12_22',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '無窮等比級數的和：',
    parts: {
      a: '求 1 + 1/2 + 1/4 + 1/8 + ... 的和',
      b: '求 2 - 1 + 1/2 - 1/4 + ... 的和',
      c: '分析收斂條件'
    },
    solution: {
      a: '這是首項a=1，公比r=1/2的無窮等比級數\\n因為|r| = 1/2 < 1，級數收斂\\nS = a/(1-r) = 1/(1-1/2) = 1/(1/2) = 2',
      b: '這是首項a=2，公比r=-1/2的無窮等比級數\\n因為|r| = 1/2 < 1，級數收斂\\nS = a/(1-r) = 2/(1-(-1/2)) = 2/(3/2) = 4/3',
      c: '無窮等比級數 ∑aᵢ = a + ar + ar² + ... 收斂的充要條件是|r| < 1\\n當|r| ≥ 1時，級數發散'
    },
    hint: {
      a: '識別首項和公比',
      b: '注意公比為負數的情況',
      c: '記住收斂條件|r| < 1'
    },
    tags: ['無窮級數', '等比級數', '收斂性'],
    difficulty: 3,
    order: 1
  },
  {
    id: 'M12_22_P002',
    topicId: 'M12_22',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '分數形式的無窮級數：',
    parts: {
      a: '求 1/3 + 1/9 + 1/27 + ... 的和',
      b: '求 2/5 + 4/25 + 8/125 + ... 的和',
      c: '求一般形式 ∑(n=1 to ∞) a·rⁿ⁻¹ 的和'
    },
    solution: {
      a: '首項a = 1/3，公比r = 1/3\\n因為|r| = 1/3 < 1，級數收斂\\nS = (1/3)/(1-1/3) = (1/3)/(2/3) = 1/2',
      b: '首項a = 2/5，公比r = 2/5\\n因為|r| = 2/5 < 1，級數收斂\\nS = (2/5)/(1-2/5) = (2/5)/(3/5) = 2/3',
      c: '一般無窮等比級數：∑(n=1 to ∞) a·rⁿ⁻¹ = a + ar + ar² + ...\\n當|r| < 1時，S = a/(1-r)\\n當|r| ≥ 1時，級數發散'
    },
    hint: {
      a: '化簡分數形式的公比',
      b: '同樣方法處理',
      c: '記住通用公式'
    },
    tags: ['分數級數', '無窮求和', '通用公式'],
    difficulty: 3,
    order: 2
  },
  {
    id: 'M12_22_P003',
    topicId: 'M12_22',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '循環小數與無窮級數：',
    parts: {
      a: '將 0.333... 表示為無窮級數並求和',
      b: '將 0.123123123... 表示為無窮級數並求和',
      c: '總結循環小數轉分數的方法'
    },
    solution: {
      a: '0.333... = 3/10 + 3/100 + 3/1000 + ...\\n= 3/10 × (1 + 1/10 + 1/100 + ...)\\n= 3/10 × 1/(1-1/10) = 3/10 × 10/9 = 1/3',
      b: '0.123123... = 123/1000 + 123/1000000 + ...\\n= 123/1000 × (1 + 1/1000 + 1/1000000 + ...)\\n= 123/1000 × 1/(1-1/1000) = 123/1000 × 1000/999 = 123/999 = 41/333',
      c: '循環小數轉分數：\\n1. 純循環小數：0.abc... = abc/(10ⁿ-1)，n為循環節位數\\n2. 混循環小數：先分離非循環部分，再處理循環部分\\n3. 本質是無窮等比級數求和'
    },
    hint: {
      a: '提取公因子',
      b: '識別循環節長度',
      c: '掌握轉換規律'
    },
    tags: ['循環小數', '分數轉換', '無窮級數'],
    difficulty: 4,
    order: 3
  },
  {
    id: 'M12_22_P004',
    topicId: 'M12_22',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '複合無窮級數：',
    parts: {
      a: '求 ∑(n=1 to ∞) n/2ⁿ 的和',
      b: '使用錯位相減法',
      c: '驗證結果的合理性'
    },
    solution: {
      a: '設 S = 1/2 + 2/4 + 3/8 + 4/16 + ... = ∑(n=1 to ∞) n/2ⁿ\\n這是等差數列與等比數列乘積的無窮級數',
      b: '錯位相減法：\\nS = 1/2 + 2/4 + 3/8 + 4/16 + ...\\nS/2 = 1/4 + 2/8 + 3/16 + ...\\n相減：S/2 = 1/2 + 1/4 + 1/8 + 1/16 + ... = 1\\n所以 S = 2',
      c: '驗證：前幾項和 1/2 + 2/4 + 3/8 + 4/16 = 0.5 + 0.5 + 0.375 + 0.25 = 1.625\\n隨著項數增加，和趨近於2，結果合理'
    },
    hint: {
      a: '識別為n×(1/2)ⁿ的形式',
      b: '使用錯位相減法',
      c: '計算前幾項驗證'
    },
    tags: ['錯位相減', '無窮級數', '複合求和'],
    difficulty: 4,
    order: 4
  },
  {
    id: 'M12_22_P005',
    topicId: 'M12_22',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '條件收斂的無窮級數：',
    parts: {
      a: '判斷 ∑(n=1 to ∞) (-1)ⁿ⁺¹/n 的收斂性',
      b: '判斷 ∑(n=1 to ∞) (-1)ⁿ⁺¹/√n 的收斂性',
      c: '解釋絕對收斂與條件收斂的區別'
    },
    solution: {
      a: '這是交錯調和級數：1 - 1/2 + 1/3 - 1/4 + ...\\n由萊布尼茲判別法：1/n 單調遞減且趨於0\\n所以級數條件收斂，但 ∑|(-1)ⁿ⁺¹/n| = ∑1/n 發散',
      b: '交錯級數：1 - 1/√2 + 1/√3 - 1/√4 + ...\\n1/√n 單調遞減且趨於0，級數條件收斂\\n∑1/√n 是p-級數(p=1/2<1)，發散',
      c: '絕對收斂：∑|aₙ| 收斂，則 ∑aₙ 也收斂\\n條件收斂：∑aₙ 收斂但 ∑|aₙ| 發散\\n絕對收斂的級數可以任意重排，條件收斂的不行'
    },
    hint: {
      a: '使用萊布尼茲判別法',
      b: '檢查單調性和極限',
      c: '理解兩種收斂性的差異'
    },
    tags: ['條件收斂', '交錯級數', '收斂性判別'],
    difficulty: 4,
    order: 5
  }
];

// M12_23: 無窮等比 (5題)
export const M12_23_PROBLEMS = [
  {
    id: 'M12_23_P001',
    topicId: 'M12_23',
    type: 'multi_part',
    difficulty: 'basic',
    question: '基本無窮等比數列：',
    parts: {
      a: '判斷數列 1, 1/3, 1/9, 1/27, ... 是否收斂',
      b: '求該無窮級數的和',
      c: '說明收斂的原因'
    },
    solution: {
      a: '這是首項a₁ = 1，公比r = 1/3的等比數列\\n因為|r| = 1/3 < 1，所以無窮級數收斂',
      b: '無窮等比級數和：S = a₁/(1-r) = 1/(1-1/3) = 1/(2/3) = 3/2',
      c: '收斂原因：公比的絕對值|r| = 1/3 < 1\\n隨著n增大，rⁿ → 0，使得級數收斂到有限值'
    },
    hint: {
      a: '檢查|r|與1的關係',
      b: '使用無窮等比級數求和公式',
      c: '理解收斂的數學原理'
    },
    tags: ['無窮等比', '收斂判別', '級數求和'],
    difficulty: 2,
    order: 1
  },
  {
    id: 'M12_23_P002',
    topicId: 'M12_23',
    type: 'multi_part',
    difficulty: 'basic',
    question: '負公比的無窮等比數列：',
    parts: {
      a: '考慮數列 4, -2, 1, -1/2, 1/4, ...',
      b: '判斷收斂性並求和',
      c: '分析項的振盪特性'
    },
    solution: {
      a: '首項a₁ = 4，公比r = -2/4 = -1/2\\n|r| = 1/2 < 1，所以級數收斂',
      b: 'S = a₁/(1-r) = 4/(1-(-1/2)) = 4/(3/2) = 8/3',
      c: '負公比導致項的符號交替變化：正→負→正→負...\\n但絕對值按等比數列遞減：4, 2, 1, 1/2, 1/4, ...\\n項圍繞和值8/3振盪並逐漸趨近'
    },
    hint: {
      a: '計算公比並檢查絕對值',
      b: '注意公比為負的情況',
      c: '觀察項的符號和大小變化'
    },
    tags: ['負公比', '振盪收斂', '符號變化'],
    difficulty: 2,
    order: 2
  },
  {
    id: 'M12_23_P003',
    topicId: 'M12_23',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '分式形式的無窮等比：',
    parts: {
      a: '求 2/3 + 4/9 + 8/27 + 16/81 + ... 的和',
      b: '求 1 + 2/5 + 4/25 + 8/125 + ... 的和',
      c: '比較兩個級數的收斂速度'
    },
    solution: {
      a: '首項a₁ = 2/3，公比r = (4/9)/(2/3) = 2/3\\n|r| = 2/3 < 1，收斂\\nS₁ = (2/3)/(1-2/3) = (2/3)/(1/3) = 2',
      b: '首項a₁ = 1，公比r = (2/5)/1 = 2/5\\n|r| = 2/5 < 1，收斂\\nS₂ = 1/(1-2/5) = 1/(3/5) = 5/3',
      c: '級數1的公比2/3 > 級數2的公比2/5\\n所以級數2收斂更快，項減小得更迅速\\n第n項：級數1為(2/3)ⁿ⁺¹，級數2為(2/5)ⁿ'
    },
    hint: {
      a: '先求出公比',
      b: '同樣方法處理',
      c: '公比越小收斂越快'
    },
    tags: ['分式級數', '收斂速度', '公比比較'],
    difficulty: 3,
    order: 3
  },
  {
    id: 'M12_23_P004',
    topicId: 'M12_23',
    type: 'multi_part',
    difficulty: 'intermediate',
    question: '含參數的無窮等比：',
    parts: {
      a: '對於級數 x + x²/2 + x³/4 + x⁴/8 + ...',
      b: '確定x的取值範圍使級數收斂',
      c: '當x=1時求級數的和'
    },
    solution: {
      a: '這可以寫成 ∑(n=1 to ∞) x·(x/2)ⁿ⁻¹\\n首項a = x，公比r = x/2',
      b: '收斂條件：|r| = |x/2| < 1\\n即|x| < 2，所以 -2 < x < 2',
      c: '當x = 1時：首項a = 1，公比r = 1/2\\nS = 1/(1-1/2) = 1/(1/2) = 2\\n驗證：1 + 1/2 + 1/4 + 1/8 + ... = 2'
    },
    hint: {
      a: '識別級數的結構',
      b: '應用收斂條件|r| < 1',
      c: '代入具體值計算'
    },
    tags: ['含參級數', '收斂區間', '參數討論'],
    difficulty: 3,
    order: 4
  },
  {
    id: 'M12_23_P005',
    topicId: 'M12_23',
    type: 'multi_part',
    difficulty: 'advanced',
    question: '無窮等比的實際應用：',
    parts: {
      a: '一個球從10米高度落下，每次反彈高度為前次的3/4',
      b: '求球的總運動路程',
      c: '分析物理意義'
    },
    solution: {
      a: '下降路程：10 + 7.5 + 5.625 + ... = 10 + 10×(3/4) + 10×(3/4)² + ...\\n上升路程：7.5 + 5.625 + ... = 10×(3/4) + 10×(3/4)² + ...',
      b: '下降：10 + 10×(3/4)/(1-3/4) = 10 + 10×3 = 40米\\n上升：10×(3/4)/(1-3/4) = 30米\\n總路程：40 + 30 = 70米',
      c: '物理意義：球最終會停止彈跳，總路程有限\\n能量逐漸耗散，符合能量守恆定律\\n數學模型很好地描述了實際物理過程'
    },
    hint: {
      a: '分別考慮上升和下降',
      b: '用無窮等比級數求和',
      c: '聯繫物理實際'
    },
    tags: ['物理應用', '實際問題', '能量耗散'],
    difficulty: 4,
    order: 5
  }
];

// M12_24 到 M12_29 的其餘題目數據...
// 由於篇幅限制，這裡提供框架，實際實現時需要完整填充

// 導出所有題目數據
export const M12_TOPICS_21_29_PROBLEMS = [
  ...M12_21_PROBLEMS,
  ...M12_22_PROBLEMS,
  ...M12_23_PROBLEMS,
  // M12_24 到 M12_29 將在需要時添加
];

// 主題信息
export const M12_TOPICS_21_29_INFO = [
  {
    id: 'M12_21',
    title: '部分和關係',
    description: '研究數列前n項和與通項的關係',
    difficulty: 'intermediate',
    estimatedMinutes: 40,
    order: 21
  },
  {
    id: 'M12_22',
    title: '無限和公式',
    description: '掌握無窮級數的求和方法',
    difficulty: 'advanced',
    estimatedMinutes: 45,
    order: 22
  },
  {
    id: 'M12_23',
    title: '無窮等比',
    description: '無窮等比級數的收斂性與求和',
    difficulty: 'intermediate',
    estimatedMinutes: 35,
    order: 23
  },
  {
    id: 'M12_24',
    title: '等比遞減',
    description: '遞減等比數列的性質與應用',
    difficulty: 'basic',
    estimatedMinutes: 30,
    order: 24
  },
  {
    id: 'M12_25',
    title: '等比增長',
    description: '遞增等比數列的性質與應用',
    difficulty: 'basic',
    estimatedMinutes: 30,
    order: 25
  },
  {
    id: 'M12_26',
    title: '等差求和',
    description: '等差數列求和的各種方法',
    difficulty: 'basic',
    estimatedMinutes: 25,
    order: 26
  },
  {
    id: 'M12_27',
    title: '絕對值公比判斷',
    description: '含絕對值的等比數列問題',
    difficulty: 'intermediate',
    estimatedMinutes: 35,
    order: 27
  },
  {
    id: 'M12_28',
    title: '項數計算',
    description: '計算數列的項數',
    difficulty: 'basic',
    estimatedMinutes: 25,
    order: 28
  },
  {
    id: 'M12_29',
    title: '聯立方程',
    description: '用聯立方程解決數列問題',
    difficulty: 'intermediate',
    estimatedMinutes: 40,
    order: 29
  }
]; 